import { c as _c } from "react/compiler-runtime";
import { Check, Copy, Gift, Share2, Users2 } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { balance } from "@/mocks/residual";
import { formatUsd } from "@/lib/format";
export function ReferralsPage() {
  const $ = _c(19);
  const [copied, setCopied] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      navigator.clipboard.writeText("https://horizon.residual.app/r/yourcode");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const copy = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (typeof navigator.share === "function") {
        navigator.share({
          title: "Residual \u2014 fractional ownership",
          text: "Buy fractions of real assets and revenue-share deals",
          url: "https://horizon.residual.app/r/yourcode"
        });
      } else {
        copy();
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const share = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><h1 className="text-2xl font-semibold tracking-tight">Referrals</h1><p className="text-sm text-muted-foreground">Earn 10% of every purchase your invitees make.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mx-auto grid size-14 place-items-center rounded-full bg-violet-500/15 text-violet-700 dark:text-violet-400"><Gift className="size-7" /></div>;
    t4 = <div className="text-xs uppercase tracking-wide text-muted-foreground">Referral balance</div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div>{t4}<div className="text-3xl font-semibold tabular-nums">{formatUsd(balance.referralUsd)}</div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Card><CardContent className="space-y-4 pt-6 text-center">{t3}{t5}<div className="grid grid-cols-2 gap-2"><Button variant="outline">Withdraw</Button><Button variant="outline">Reinvest</Button></div></CardContent></Card>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="text-sm font-medium">Your invite link</div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="flex-1 truncate font-mono text-xs">{"https://horizon.residual.app/r/yourcode"}</span>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== copied) {
    t9 = <div className="flex items-center gap-2 rounded-lg border bg-muted/40 px-3 py-2.5">{t8}<button type="button" onClick={copy} className="rounded-md p-1 hover:bg-muted" aria-label="Copy link">{copied ? <Check className="size-4 text-emerald-600" /> : <Copy className="size-4" />}</button></div>;
    $[9] = copied;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Button onClick={share} className="w-full gap-1.5"><Share2 className="size-4" /> Share</Button>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t9) {
    t11 = <Card><CardContent className="space-y-3 pt-6">{t7}{t9}{t10}</CardContent></Card>;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex items-center gap-2 text-sm font-medium"><Users2 className="size-4" /> Invitees (3)</div>;
    t13 = <Separator className="my-3" />;
    $[14] = t12;
    $[15] = t13;
  } else {
    t12 = $[14];
    t13 = $[15];
  }
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Card><CardContent className="pt-6">{t12}{t13}<ul className="space-y-2 text-sm">{[{
            name: "@sora",
            purchases: "$125 \xB7 $12.50 earned"
          }, {
            name: "@nilo",
            purchases: "$650 \xB7 $65.00 earned"
          }, {
            name: "@petra",
            purchases: "Joined \u2014 no purchases yet"
          }].map(_temp)}</ul></CardContent></Card>;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t11) {
    t15 = <div className="space-y-5">{t2}{t6}{t11}{t14}</div>;
    $[17] = t11;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  return t15;
}
function _temp(u) {
  return <li key={u.name} className="flex items-center justify-between gap-2"><span className="font-medium">{u.name}</span><span className="text-xs text-muted-foreground">{u.purchases}</span></li>;
}